import "core-js/modules/es.array.reverse.js";
var _class, _class2;
import "core-js/modules/es.symbol.description.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import { Component } from "react";
import CommonStrata from "../../Models/Definition/CommonStrata";
import Icon from "../../Styled/Icon";
import Styles from "./parameter-editors.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let BooleanParameterEditor = observer(_class = (_class2 = class BooleanParameterEditor extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }
  onClick() {
    this.props.parameter.setValue(CommonStrata.user, !this.props.parameter.value);
  }
  renderCheckbox() {
    const value = this.props.parameter.value;
    const name = this.props.parameter.name;
    const description = this.props.parameter.description;
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("button", {
        type: "button",
        className: Styles.btnRadio,
        title: description,
        onClick: this.onClick.bind(this),
        children: [value && /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.checkboxOn
        }), !value && /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.checkboxOff
        }), name]
      })
    });
  }
  renderRadio(state) {
    let name;
    let description;
    const value = this.props.parameter.value === state;
    if (state === true) {
      name = this.props.parameter.trueName || this.props.parameter.name;
      description = this.props.parameter.trueDescription || this.props.parameter.description;
    } else {
      name = this.props.parameter.falseName || this.props.parameter.name;
      description = this.props.parameter.falseDescription || this.props.parameter.description;
    }
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("button", {
        type: "button",
        className: Styles.btnRadio,
        title: description,
        onClick: this.onClick.bind(this),
        children: [value && /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.radioOn
        }), !value && /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.radioOff
        }), name]
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsxs("div", {
      children: [!this.props.parameter.hasNamedStates && this.renderCheckbox(), this.props.parameter.hasNamedStates && /*#__PURE__*/_jsxs("div", {
        children: [this.renderRadio(true), this.renderRadio(false)]
      })]
    });
  }
}, _applyDecoratedDescriptor(_class2.prototype, "onClick", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onClick"), _class2.prototype), _class2)) || _class;
export { BooleanParameterEditor as default };